import Module from '@/store/resource/common/module';
import FormRecords from '@/store/resource/formRecords';

import api from '@/factories/api';
import cloneDeep from 'lodash/cloneDeep';

let module = new Module(new FormRecords());

module.add('state', {
  submissionsCountCache: {},
});

module.add('getters', {
  getSubmissionsCount: (state) => (collectionId) => {
    return state.submissionsCountCache[collectionId] || 0;
  },
  formRecordOptions: (state) => {
    return cloneDeep(state.all)
      .filter((item) => item.name) // Filter out items without a name
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      .reduce(
        (accObj, item) => {
          accObj[item.id] = item.name;
          return accObj;
        },
        { '': '' }
      );
  },
});

module.add('mutations', {
  setSubmissionsCount(state, { collectionId, count }) {
    state.submissionsCountCache = {
      ...state.submissionsCountCache,
      [collectionId]: count,
    };
  },
  adjustSubmissionsCount(state, { collectionId, delta }) {
    const current = state.submissionsCountCache[collectionId] || 0;
    const newCount = Math.max(0, current + delta);
    state.submissionsCountCache = {
      ...state.submissionsCountCache,
      [collectionId]: newCount,
    };
  },
  clearSubmissionsCount(state, collectionId) {
    const { [collectionId]: _, ...rest } = state.submissionsCountCache;
    state.submissionsCountCache = rest;
  },
});

module.add('actions', {
  async getBuilderToken({ commit }, payload) {
    return api().post('form/builder_token', payload);
  },

  async generateSigningDocument(_, { submissionId, inPortal, data }) {
    const basePath = inPortal ? 'portal/form' : 'form';
    const path = `${basePath}/submissions/${submissionId}/generate`;

    return api().post(path, data);
  },

  async fetchSignedDocument(_, { submissionId, inPortal, field }) {
    const basePath = inPortal ? 'portal/form' : 'form';
    const path = `${basePath}/submissions/${submissionId}/documents`;

    const res = await api().get(path, {
      params: { field },
    });

    return Array.isArray(res) ? res[0] : res;
  },

  async loadSubmissionsCount({ commit }, collectionId) {
    if (!collectionId) return 0;

    const params = { obj_id: collectionId, page: 1, per_page: 1 };
    const data = await api().get('form/submissions', { params });
    const count = data?.count || 0;

    commit('setSubmissionsCount', { collectionId, count });
    return count;
  },
});

export default module.create();
